import { space } from "./space";

export const NAVBAR_HEIGHT = 80;
export const FOOTER_HEIGHT = 50;
export const LEFT_CONTAINER_WIDTH = 250;
export const GRID_GAP_VERTICAL = space.xl;
export const GRID_GAP_HORIZONTAL = space.xxl;
export const MAX_WIDTH = `calc(100% - ${space.l})`;

export enum ContentWidth {
  wide = "1200px",
  default = "900px",
  narrow = "600px",
}
